<template>
  <v-layout pl-2 pt-2 pr-2 pb-2 justify-center row>
    <v-flex xs12>
      <v-layout row wrap align-content-center justify-center>
        <v-flex xs12>
          <v-card>
            <v-toolbar color="primary" dark>
              <v-toolbar-title>Ride Types</v-toolbar-title>
              <v-divider class="mx-3" inset vertical></v-divider>
              <h4 class="nobold">Drag and drop to re-order</h4>
              <v-divider class="mx-3" inset vertical></v-divider>
              <v-flex shrink>
                <h5 class="nobold">Get a cost estimate:&nbsp;&nbsp;</h5>
              </v-flex>
              <v-flex xs4 md6 pt-1 class="make-small">
                <CostEstimate
                  v-if="!loading"
                  :rideTypes="ride_types"
                  @estimates="populateEstimates($event)"
                  @loading="setLoadingEstimates($event)"
                />
              </v-flex>
              <v-spacer></v-spacer>
              <v-btn icon @click="$router.push('/settings/pricing/ride_types/create')">
                <v-icon>add</v-icon>
              </v-btn>
            </v-toolbar>
            <RideTypeList
              v-if="!loading"
              style="width: 100%;"
              :ride_types="ride_types"
              :loading="loading"
              :loadingCostEstimates="loadingCostEstimates"
              @orderChange="changeRideTypeOrder($event)"
              @edit="editRideType($event)"
            ></RideTypeList>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-snackbar v-model="snackbarShow" :color="snackbarColour" :timeout="4000">
      <v-layout align-center justify-center>{{ snackbarMessage }}</v-layout>
    </v-snackbar>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import RideTypeList from "@/components/settings/pricing/RideTypeList.vue";
import CostEstimate from "@/components/settings/pricing/CostEstimate.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "ride_types",
  components: {
    SimpleCard,
    RideTypeList,
    CostEstimate
  },
  data: function() {
    return {
      ride_types: [],
      loading: true,
      snackbarShow: false,
      snackbarMessage: null,
      snackbarColour: null,
      loadingCostEstimates: false
    };
  },
  mounted: async function() {
    this.getRideTypes();
    this.loading = false;
  },
  methods: {
    getRideTypes: async function() {
      try {
        let url = `${this.$store.state.apiUrl}/settings/ride_types/getAll`;

        let response = await axios.get(url, {
          params: {}
        });
        let sortedRideTypes = response.data.ride_types;

        sortedRideTypes.sort(function(a, b) {
          return a.priority - b.priority;
        });

        this.ride_types = sortedRideTypes;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get ride types " + error);
      }
    },
    changeRideTypeOrder: async function(rideTypesNew) {
      if (rideTypesNew) {
        for (let i = 0; i < rideTypesNew.length; i++) {
          rideTypesNew[i].priority = i + 1;
        }

        let self = this;
        let url = `${this.$store.state.apiUrl}/settings/ride_types/reorder`;
        axios({
          url: url,
          method: "post",
          data: {
            ride_types: rideTypesNew
          },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.showSnackbar("Error changing ride type order", "success");
            } else if (response.data.error != "no_error") {
              self.showSnackbar(
                "Error changing ride type order" + response.data.error,
                "success"
              );
              console.log(response.data.error);
            } else {
              self.showSnackbar("Ride type order changed", "success");
              this.ride_types = rideTypesNew;
            }
          })
          .catch(function(error) {
            console.log(error);
            //self.showSnackbar("Network error: " + error, "error");
          });
      }
    },
    showSnackbar: function(message, colour) {
      this.snackbarMessage = message;
      this.snackbarColour = colour;
      this.snackbarShow = true;
    },
    editRideType: function(id) {
      console.log("Launching edit ride type");
      this.$router.push("./ride_types/edit/" + id);
    },
    populateEstimates: function(estimates) {
      this.loadingCostEstimates = false;
      const formatter = new Intl.NumberFormat("en-UK", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 2
      });
      for (let i = 0; i < this.ride_types.length; i++) {
        //Weird way to get vue to update
        let updatedRideType = JSON.parse(JSON.stringify(this.ride_types[i]));
        if (estimates[updatedRideType.id]) {
          updatedRideType.estimatedCost = formatter.format(
            estimates[updatedRideType.id] / 100
          );
          this.$set(this.ride_types, i, updatedRideType);
        }
      }
    },
    setLoadingEstimates: function(loading) {
      this.loadingCostEstimates = loading;
    }
  }
};
</script>

<style>
.nobold {
  font-weight: normal;
}

#make-small {
  transform: scale(0.8);
  transform-origin: left;
}
.make-small {
  transform: scale(0.8);
  transform-origin: left;
}
</style>